<div>
  <div class="content-container text-end p-4 pt-2">
    <button
				type="button"
				class="btn-close"
				aria-describedby="modal-title"
				(click)="modal.dismiss('Cross click')"
			></button>
  </div>

  <div class="text-center">
    <img src="assets/sad-chat.svg" alt="">
  </div>

  <div class="content-container">
    <div class="col-12">
      <p class="text-center content-span h2 d-block full-width fw-bold">{{messageTitle}}</p>
    </div>
  </div>

  <div class="content-container">
    <div class="col-12">
      <p class="text-center content-span small full-width fw-bold text-black-50">{{messageBody}}</p>
    </div>
  </div>

  <div class="container mt-5">
    <div class="d-flex pb-4 justify-content-center flex-column align-items-center gap-3">
      <div class="p-0 action button-1">
        <button ngbAutofocus (click)="modal.close('Ok click')" >{{nextButton || 'YES'}}</button>
      </div>
      <div class="p-0 action button-2">
        <button (click)="modal.dismiss('cancel click')">{{cancelButton || 'NO'}}</button>
      </div>
    </div>
  </div>
</div>
